import { uniq } from 'es-toolkit';
import React, { ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material';

import { INDETERMINATE, PropertySelectField } from '@paragon/client-tools';

interface Props<T> {
  readonly property: ReactNode;
  readonly values: ReadonlyArray<T>;
  readonly options: ReadonlyArray<T>;
  readonly getName?: (t: T) => React.ReactNode;
  readonly disabled?: boolean;
  readonly submit?: (value: T) => void;
  readonly fullWidth?: boolean;
  readonly sx?: SxProps<Theme>;
}

export function MultiValueSelectInput<T extends {}>(props: Props<T>) {
  const uniqueValues = uniq(props.values);
  const value = uniqueValues.length === 1 ? uniqueValues[0] : INDETERMINATE;

  return (
    <PropertySelectField<T>
      property={props.property}
      value={value}
      options={props.options}
      getName={props.getName}
      disabled={props.disabled}
      submit={props.submit}
      fullWidth={props.fullWidth}
      sx={props.sx}
    />
  );
}
